import React from "react";
import Layout from "../../shared/Layout/Layout";
import Hero from "../../containers/_home/Hero/Hero";
import Trending from "../../containers/_home/Trending/Trending";
import Popular from "../../containers/_home/Popular/Popular";
import Newest from "../../containers/_home/Newest/Newest";
import Sell from "../../containers/_home/Sell/Sell";

const Home = () => {
  return (
    <Layout>
      <Hero />
      <Trending />
      <Popular />
      <Newest />
      <Sell />
    </Layout>
  );
};

export default Home;
